<template>
  <div class="pen-menu-component">
    <div class="menu-section">
      <p class="section-title">画笔粗细</p>
      <ul class="size-list">
        <li
          v-for="size in penSizes"
          :key="size"
          :class="{ active: selectedSize === size }"
          @click="handleSizeSelect(size)"
        >
          <img
            class="size-dot"
            :src="require('../../assets/images/size' + size + '.png')"
            alt=""
          />
        </li>
      </ul>
    </div>
    <div class="menu-section">
      <p class="section-title">画笔颜色</p>
      <ul class="color-list">
        <li
          v-for="color in penColors"
          :key="color"
          :class="{ active: selectedColor === color }"
          @click="handleColorSelect(color)"
        >
          <div class="color-dot" :style="{ backgroundColor: color }"></div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "PenMenu",
  data() {
    return {
      penSizes: [50, 75, 100],
      penColors: [
        "#000000",
        "#E2584F",
        "#F6C847",
        "#65C445",
        "#456FF6",
        "#7640EC",
      ],
      selectedSize: 50,
      selectedColor: "#000000",
    };
  },
  mounted() {
    const initColor = this.whiteBoardService.getBrushColor();
    const initSize = +this.whiteBoardService.getBrushThin();
    this.selectedColor = this.rgbaToHex(initColor);
    this.selectedSize = initSize;
  },
  methods: {
    rgbaToHex(rgba) {
      const result = rgba.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/i);
      if (!result) return "#cccccc";
      const r = parseInt(result[1]).toString(16).padStart(2, "0");
      const g = parseInt(result[2]).toString(16).padStart(2, "0");
      const b = parseInt(result[3]).toString(16).padStart(2, "0");
      return `#${r}${g}${b}`.toUpperCase();
    },
    handleSizeSelect(size) {
      if (this.selectedSize === size) return;
      this.selectedSize = size;
      this.handleStyleChange();
    },
    handleColorSelect(color) {
      if (this.selectedColor === color) return;
      this.selectedColor = color;
      this.handleStyleChange();
    },
    handleStyleChange() {
      this.whiteBoardService.setPenStyle({
        color: this.selectedColor,
        size: this.selectedSize,
      });
    },
  },
  computed: {
    ...mapState("live", ["whiteBoardService"]),
  },
};
</script>

<style lang="scss" scoped>
.pen-menu-component {
  width: 167px;
  // height: 189px;
  background: #ffffff;
  box-shadow: 0px 4px 10px 0px rgba(20, 20, 43, 0.04);
  border-radius: 10px;
  border: 1px solid $live-room-border-color;
  padding: 0 12px;

  .menu-section {
    padding: 12px 0 4px;
    border-bottom: 1px solid $live-room-border-color;

    &:last-child {
      border: none;
    }
  }

  .section-title {
    font-weight: 500;
    font-size: 12px;
    color: #4e5969;
    line-height: 20px;
    margin-bottom: 4px;
  }

  ul {
    display: flex;
    flex-wrap: wrap;
    li {
      margin-right: 40px;
      &:nth-child(3n) {
        margin-right: 0;
      }
      margin-top: 8px;
      margin-bottom: 8px;
    }
  }

  .size-list {
    li {
      margin-right: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 0.3s;
      width: 28px;
      height: 28px;
      border-radius: 6px;

      &:hover,
      &:focus {
        background: $live-room-hover-bg;
      }
      &.active {
        background: $live-room-active-bg;
      }

      .size-dot {
        width: 20px;
        height: 20px;
      }
    }
  }

  .color-list {
    li {
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      position: relative;

      &.active::after,
      &:hover::after {
        display: block;
        content: "";
        width: 12px;
        height: 12px;
        border-radius: 50%;
        border: 2px solid #ffffff;
        background: transparent;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }

      .color-dot {
        width: 20px;
        height: 20px;
        border-radius: 50%;
      }
    }
  }
}
</style>
